import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BecomeSellerComponent } from '../../shared/dialogs/become-seller/become-seller.component';
import { filter, take, tap } from 'rxjs';
import { Router } from '@angular/router';
import { role } from '../constants/keys.const';
import { ToasterService } from './toastr.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentsModalService {
  constructor(
    public readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly toastrService: ToasterService,
    private readonly translateService: TranslateService,
  ) { }

  public openUploadDocumentsModal(currentRole: typeof role[keyof typeof role]): void {
    const modal = this.dialog.open<
      BecomeSellerComponent,
      MatDialogConfig,
      boolean
      >(BecomeSellerComponent, { panelClass: ['modall', 'digital_sign_mdl'] });
  
    modal
      .afterClosed()
      .pipe(
        filter(Boolean),
        tap(() =>
          this.router.navigate(['/auth/upload-document'], {
            queryParams: {
              becomeSeller: currentRole === role.BUYER,
              role: currentRole,
            },
          })
        ),
        take(1)
      )
      .subscribe();
  }

  public openWaitForVerificationToaster(): void {
    this.toastrService.errToastr(this.translateService.instant('TOASTER.WaitForAdminToVerify'));
  }
}
